import { render, staticRenderFns } from "./SupplierStockPriceMarkdownComponent.vue?vue&type=template&id=6eb61ce8&"
import script from "./SupplierStockPriceMarkdownComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockPriceMarkdownComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports